<h1>Meine Favoriten</h1>

<div *ngIf="churches">
    <div [class.ka-separator]="i > 0" *ngFor="let churcht of churches | keyvalue; let i = index">
        <app-church-widget *ngIf="churcht.value" [church]="churcht.value">
        </app-church-widget>
    </div>
</div>